import {IPerson} from 'app/models/person'
import {JsonObject} from 'utilities/types'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'

export class CPerson extends CGraphEntity<IPerson> implements IPerson {
  static children = {
    notes: CNote,
  }

  first_name
  last_name
  email
  domain
  phone_number
  title
  country
  city
  state
  headline
  social_media
  organization_name
  org_social_media

  constructor(data: IPerson & JsonObject) {
    super('Person', data)
    this.first_name = data.first_name
    this.last_name = data.last_name
    this.email = data.email
    this.domain = data.domain
    this.phone_number = data.phone_number
    this.title = data.title
    this.country = data.country
    this.city = data.city
    this.state = data.state
    this.headline = data.headline
    this.social_media = data.social_media
    this.organization_name = data.organization_name
    this.org_social_media = data.org_social_media
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  export() {
    return {id: this.id}
  }
}
